import { Target } from "lucide-react";
import { formatDate } from "../../lib/utils";
import { Goal } from "../../types/goals";

interface GoalHeaderProps {
    goal: Goal;
}
const GoalHeader = ({ goal }: GoalHeaderProps) => (
    <div className="flex items-center space-x-3">
        <div className="p-2 bg-blue-100 dark:bg-blue-900/50 rounded-lg">
            <Target className="w-6 h-6 text-blue-600 dark:text-blue-400" />
        </div>
        <div>
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white">
                {goal.title}
            </h2>
            <p className="text-sm text-gray-500">
                {formatDate(goal.startDate)} - {formatDate(goal.endDate)}
            </p>
        </div>
    </div>
);

export default GoalHeader;